export default __webpack_public_path__ + "printing-tool.png";